// Gentle parallax on hero image (front page) – uses GSAP ScrollTrigger
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function heroParallax() {
	function initHeroParallax() {
		const hero = document.querySelector('.hero');
		const heroMedia = document.querySelector('.hero__image');
		if (!hero || !heroMedia) return;

		gsap.to(heroMedia, {
			y: '+=15%',
			ease: 'none',
			scrollTrigger: {
				trigger: hero,
				start: 'top top',
				end: 'bottom top',
				scrub: true,
			},
		});
	}
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHeroParallax);
	} else {
		initHeroParallax();
	}  
}
